<div class="card-body">
    <div id="apex-line-with-data-labels"></div>
</div>